export const RG_ROUTES = {
  account: '/restaurant-group/account',
  report_earnings: '/restaurant-group/reports/earnings',
};
